const Loading = () => {
  return (
    <div className="fixed w-full h-screen bg-gray-50 bg-opacity-60 z-30">
      <div className="flex justify-center items-center h-screen flex-col">
        <div className="spinner-border animate-spin w-8 h-8 border-4 rounded-full border-t-transparent border-blue-500 block" />
        <div className="mt-2">Processing....</div>
      </div>
    </div>
  );
};

export default Loading;
